import { withData } from '@services/surveyDataProvider';

import PanelCategoryDetails from './PanelCategoryDetails';

const mapSurveyDataToProps = (surveyData) => ({
  rawCookieBanner: surveyData.cookieBanner
});

export default withData(mapSurveyDataToProps)(PanelCategoryDetails);
